<template>
	<card bg="bg-dark text-white" title="Muestras Solicitadas">
		<div class="card mt-4">
			<div v-if="request.requiredDispatch" class="row justify-content-end">
				<div class="col-md-12">
					<div class="mt-4" style="height: 40px; width: 100%">
						<div class="col text-right">
							<button class="btn btn-success" @click="showDispatchModal">
								<i class="fas fa-truck"></i>
								Despachar {{ buttonText }}
							</button>
						</div>
					</div>
				</div>
			</div>
			<div class="card-body">
				<card v-if="detailNew.length > 0" title="Nuevo Producto">
					<div class="table-responsive">
						<div v-for="item in detailNew" :key="item.id">
							<div class="card mb-4 cardShadow">
								<span :id="`detailid-${item.id}`" :data-detailid="item.id"
									:data-validated="item.wineryValidatedAt != null ? 1 : 0" style="display: none"></span>
								<div class="card-header">
									<div class="row">
										<div class="col-md-8">
											<h5 class="card-title d-inline"><b>VINO: {{ item.variety }}
												{{ item.valley }} {{ item.quality }}</b></h5>
										</div>
										<div class="col-md-4 text-right">
											<b-form-checkbox v-if="item.sampleDetailStage == 5 && request.requiredDispatch" class="mt-2"
													switch @change="addSample(item)">
													Seleccionado
												</b-form-checkbox>
										</div>
									</div>
								</div>
								<div class="card-body">
									<div class="row">
										<div class="col-md-12 text-right">
											<div v-if="item.sampleDetailStage > 0" :id="'status-color-' + item.id">
												<h4>
													<b><span :class="'badge ribbon-h-' +item.statusColor" :id="'status-text-' + item.id">
														<i class="fa fa-info-circle mr-4"></i>Estado: {{ item.status }}
													</span></b>
												</h4>
											</div>
										</div>
										<div class="col-md-12">
											<table class="table table-striped table-hover table-bordered">
												<thead class="thead-dark">
													<tr>
														<th>Marca</th>
														<th v-if="item.comercialMixCode" style="width: 20%">
															Mezcla Comercial
														</th>
														<th>Vino</th>
														<th>Botellas</th>
														<th>Etapa</th>
													</tr>
												</thead>
												<tbody>
													<tr style="font-size: 20px !important;">
														<td>
															<span class="badge badge-info p-2">{{ item.brand }}</span>
														</td>
														<td v-if="item.comercialMixCode">
															<span class="badge badge-info p-2">
																{{ item.comercialMix }} - {{ item.comercialMixCode }}
															</span>
														</td>
														<td>
															<span class="badge badge-info p-2">{{ item.variety }}</span> 
																														<span class="badge badge-info p-2 ml-1">{{ item.valley }}</span>
															<span class="badge badge-info p-2 ml-1">{{ item.quality }}</span>
														</td>
														<td>
															<span class="badge badge-success p-2">{{ item.quantity }}</span>
														</td>
														<td>
															<span class="badge badge-info p-2">
																<i class="fa fa-info-circle"></i>
																{{ item.stage }}
															</span>
														</td>
													</tr>
												</tbody>
											</table>
											<table
												class="table table-striped table-hover table-bordered">
												<tr class="thead-dark text-center">
													<th>Muestra Enológica</th>
													<th>Con Degustación</th>
													<th>Con Cosecha Histórica/Próxima</th>
													<th>Cosecha Final <i class="fas fa-info-circle text-muted ml-1" title="Para despacho"></i></th>
												</tr>
												<tr class="text-center" style="font-size: 20px !important;">
													<td>
														<i v-if="item.wineSample" class="fa fa-check text-success"></i>
														<i v-if="!item.wineSample" class="fa fa-times text-danger"></i>
													</td>
													<td>
														<i v-if="item.withTasting" class="fa fa-check text-success"></i>
														<i v-if="!item.withTasting" class="fa fa-times text-danger"></i>
													</td>
													<td>
														<i v-if="item.isHistoricalOrUpcoming" class="fa fa-check text-success"></i>
														<i v-if="!item.isHistoricalOrUpcoming" class="fa fa-times text-danger"></i>
													</td>
													<td>
														<span class="badge badge-success p-2">{{ item.finalHarvest }}</span>
													</td>
												</tr>
											</table>
											<table class="table table-striped table-hover table-bordered"
												v-if="item.estimatedDeliveryDateOenology
												|| item.deliveryDateOenology
												|| item.wineryValidatedAt
												|| item.qualityValidationDate
												|| item.wineryDispatch
												|| item.internalDispatchGuide"
											>
												<tr class="thead-dark">
													<th v-if="item.estimatedDeliveryDateOenology">Entrega Estimada Enología</th>
													<th v-if="item.deliveryDateOenology">Entrega Enología</th>
													<th v-if="item.wineryValidatedAt">Validación de Componentes</th>
													<th v-if="item.qualityValidationDate">Validacion de Calidad</th>
													<th v-if="item.wineryDispatch">Despacho desde Bodega</th>
													<th v-if="item.internalDispatchGuide">N° Guía Bodega</th>
												</tr>
												<tr>
													<td v-if="item.estimatedDeliveryDateOenology">
														<span class="badge badge-warning" style="font-size: 16px">{{
															item.estimatedDeliveryDateOenologyString }}</span>
													</td>
													<td v-if="item.deliveryDateOenology">
														<span class="badge badge-success" style="font-size: 16px">{{
															item.deliveryDateOenologyString }}</span>
													</td>
													<td v-if="item.wineryValidatedAt">
														<span  class="badge badge-success"
															style="font-size: 16px">{{ item.wineryValidatedAtString }}</span>
													</td>
													<td v-if="item.qualityValidationDate">
														<span class="badge badge-success" style="font-size: 16px">
															{{ item.qualityValidationDateString }}
														</span>
													</td>
													<td v-if="item.wineryDispatch">
														<span class="badge badge-primary" style="font-size: 16px">{{
															item.wineryDispatchString }}</span>
													</td>
													<td v-if="item.internalDispatchGuide">
														<span class="badge badge-primary" style="font-size: 16px">{{
															item.internalDispatchGuide }}</span>
													</td>
												</tr>
											</table>
										</div>
									</div>
									<div v-if="item.reasonRedoComponents" class="card mb-4 bg-warning">
										<div class="card-body">
											<span class="text-white">
												<b>Motivo de revisión: </b>
												{{ item.reasonRedoComponents }}
											</span>
										</div>
									</div>
									<div v-if="item.rejectionReason" class="card mb-4 bg-danger">
										<span class="text-white">
											<b>Motivo de rechazo: </b>
											{{ item.rejectionReason }}
										</span>
									</div>
									<div v-if="item.cancelledReason">
										<span class="text-white">
											<b>Motivo de cancelación: </b>
											{{ item.cancelledReason }}
										</span>
									</div>
									<a :aria-controls="'collapse' + item.id" :href="'#collapse' + item.id"
										aria-expanded="false" class="btn btn-info btn-block" data-toggle="collapse"
										role="button" @click="ChangeIconCollapse(item.id)">Ver más
										<i :id="'icon' + item.id" class="fas fa-angle-down"></i>
									</a>
									<div :id="`collapse${item.id}`" class="row collapse multi-collapse mt-2">
										<div class="col-lg-6 col-md-12 col-sm-12">
											<table class="table table-striper table-hover table-bordered">
												<thead class="thead-dark">
													<tr>
														<th colspan="5">Componentes Asociados</th>
													</tr>
												</thead>
												<thead class="thead-light">
													<tr>
														<th style="width: 16%">Tipo</th>
														<th style="width: 15%">Código</th>
														<th>Descripción</th>
													</tr>
												</thead>											
												<thead class="thead-light">
													<tr>
														<th>Capsula</th>
														<td>{{ item.capsuleCode }}</td>
														<td>{{ item.capsuleName }}</td>												
													</tr>
													<tr>
														<th>Tapa</th>
														<td>{{ item.cappingCode }}</td>
														<td>{{ item.cappingName }}</td>													
													</tr>
													<tr>
														<th>Caja</th>
														<td>{{ item.boxCode }}</td>
														<td>{{ item.boxName }}</td>													
													</tr>
													<tr>
														<th>Etiqueta</th>
														<td>{{ item.labelCode }}</td>
														<td>{{ item.labelName }}</td>														
													</tr>
													<tr>
														<th>Contraetiqueta</th>
														<td>{{ item.backLabelCode }}</td>
														<td>{{ item.backLabelName }}</td>														
													</tr>
												</thead>
											</table>
											<table class="table table-striped table-bordered">
												<tr class="thead-dark">
													<th colspan="2">Otro Semielaborado</th>
												</tr>
												<tr v-if="item.otherSemiElaborateCode">
													<td style="width: 22%">
														{{ item.otherSemiElaborateCode }}
													</td>
													<td style="width: 78%;">
														{{ item.otherSemiElaborateName }}
													</td>
												</tr>
												<tr v-else="">
													<td colspan="2" style="width: 73%">
														<span class="badge badge-info">No Establecido</span>
													</td>
												</tr>
											</table>										
										</div>
										<div v-if="item.isNewComposition == true" class="col-md-6">
											<table class="table table-striped table-hover table-bordered">
												<thead class="thead-dark">
													<tr>
														<th colspan="2">
															Nueva Composición
														</th>
													</tr>
												</thead>
												<thead class="thead-light">
													<tr>
														<th>Variedad</th>
														<th>Porcentaje</th>
													</tr>
													<tr v-for="composition in item.compositionDetails"
														:key="composition.id">
														<td v-if="item.id ===
															composition.requestCommercialSampleDetailID
															">
															{{ composition.variety }}
														</td>
														<td v-if="item.id ===
															composition.requestCommercialSampleDetailID
															">
															{{ composition.percent }}%
														</td>
													</tr>
												</thead>
											</table>
										</div>
										<div class="col-md-6">
											<table class="table table-striped table-hover table-bordered">
												<thead class="thead-light">
													<tr>
														<th style="width: 25%">
															Obs. Preparación del Vino
														</th>
														<td>{{ item.preparationRemarks }}</td>
													</tr>
													<tr>
														<th>Glosa Sticker</th>
														<td>{{ item.stickerGloss }}</td>
													</tr>
													<tr>
														<th>Confección Packaging</th>
														<td>{{ item.confectionRemarks }}</td>
													</tr>
												</thead>
											</table>
										</div>
										<div class="col-md-12">
											<table class="table table-stripped table-bordered">
												<thead class="thead-light">
													<tr>
														<th colspan="3">Observaciones Adicionales</th>
													</tr>
													<tr v-if="item.requestDetailObservations">
														<th style="width: 18%">Fecha</th>
														<th style="width: 12%">Usuario</th>
														<th style="width: 70%">Observación</th>
													</tr>
												</thead>
												<tbody>
													<tr v-for="observation in item.requestDetailObservations" :key="observation.id">
														<td>{{ observation.createdAtString }}</td>
														<td>{{ observation.email }}</td>
														<td>{{ observation.observation }}</td>
													</tr>
													<tr>
														<td colspan="3">
															<div class="row">
																<div class="col-10">
																	<input class="form-control" :id="'observation-input-' + item.id" type="text" />
																</div>
																<div class="col-2">
																	<button class="btn btn-success float-right" @click="addObservation(item.id)">
																		<i class="fa fa-save"></i>
																		<span class="ml-2">Registrar Observación</span>
																	</button>
																</div>
															</div>
														</td>
													</tr>
												</tbody>
											</table>
										</div>
										<div class="col-md-12">
											<table class="table table-stripped table-hover table-bordered">
												<thead class="thead-light">
													<tr>
														<th colspan="5">Documentos Adjuntos</th>
													</tr>
													<tr v-if="item.documentFiles.length > 0">
														<th style="width: 18%">Usuario</th>
														<th style="width: 12%">Fecha de Carga</th>
														<th style="width: 54%">Nombre del Archivo</th>
														<th style="width: 8%">Tipo de Archivo</th>
														<th style="width: 8%">Opciones</th>
													</tr>
												</thead>
												<tbody>
													<tr v-for="doc in item.documentFiles" :key="doc.id">
														<td>{{ doc.email }}</td>
														<td>{{ doc.createdAtString }}</td>
														<td>{{ doc.fileName }}</td>
														<td style="font-size: 20px">
															<span v-if="doc.fileExtension == '.pdf'"
																class="text-danger"><i aria-hidden="true"
																	class="fas fa-file-pdf"></i></span>
															<span v-if="doc.fileExtension == '.jpg' ||
																doc.fileExtension == '.png'
																" class="text-info"><i aria-hidden="true" class="fas fa-image"></i></span>
															<span v-if="doc.fileExtension == '.xls' ||
																doc.fileExtension == '.xlsx'
																" class="text-success"><i aria-hidden="true" class="fas fa-file-excel"></i></span>
															<span v-if="doc.fileExtension == '.doc' ||
																doc.fileExtension == '.docx'
																" class="text-primary"><i class="fas fa-file-word"></i></span>
														</td>
														<td>
															<button class="btn btn-sm btn-success mr-2"
																@click="downloadFile(doc.id)">
																<i class="fa fa-download"></i>
															</button>
														</td>
													</tr>
												</tbody>
											</table>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</card>
				<card v-if="detailFinish.length > 0" title="Producto Terminado">
					<div class="table-responsive">
						<div v-for="item in detailFinish" :key="item.id">
							<div class="card mb-4 cardShadow">
								<span :id="`detailid-${item.id}`" :data-detailid="item.id"
									:data-validated="item.wineryValidatedAt != null ? 1 : 0" style="display: none"></span>
								<div class="card-header">
									<div class="row">
										<div class="col-md-8">
											<h5 class="card-title d-inline"><b>SKU: {{ item.sku }}</b></h5>
										</div>
										<div class="col-md-4 text-right">
											<b-form-checkbox v-if="item.sampleDetailStage == 5 && request.requiredDispatch" class="mt-2"
												switch @change="addSample(item)">
												Seleccionado
											</b-form-checkbox>
										</div>
									</div>
								</div>
								<div class="card-body">
									<div class="row">
										<div class="col-md-12 text-right">
											<div v-if="item.sampleDetailStage > 0" :id="'status-color-' + item.id">
												<h4>
													<b><span :class="'badge ribbon-h-' +item.statusColor" :id="'status-text-' + item.id">
														<i class="fa fa-info-circle mr-4"></i>Estado: {{ item.status }}
													</span></b>
												</h4>
											</div>
										</div>
										<div class="col-md-12">
											<table class="table table-striped table-hover table-bordered">
												<thead class="thead-dark">
													<tr>
														<th>Sku</th>
														<th>Marca</th>
														<th v-if="item.comercialMixCode" style="width: 20%">
															Mezcla Comercial
														</th>
														<th>Vino</th>
														<th>Botellas</th>
														<th>Etapa</th>
													</tr>
												</thead>
												<tbody>
													<tr style="font-size: 20px !important;">
														<td>
															<span class="badge badge-info p-2">{{ item.sku }}</span>
														</td>
														<td>
															<span class="badge badge-info p-2">{{ item.brand }}</span>
														</td>
														<td v-if="item.comercialMixCode">
															<span class="badge badge-info p-2">
																{{ item.comercialMix }} -   {{ item.comercialMixCode }}
															</span>
														</td>
														<td>
															<span class="badge badge-info p-2">{{ item.variety }}</span> 
																														<span class="badge badge-info p-2 ml-1">{{ item.valley }}</span>
															<span class="badge badge-info p-2 ml-1">{{ item.quality }}</span>
														</td>
														<td>
															<span class="badge badge-success p-2">{{ item.quantity }}</span>
														</td>
														<td>
															<span class="badge badge-info p-2">
																<i class="fa fa-info-circle"></i>
																{{ item.stage }}
															</span>
														</td>
													</tr>
												</tbody>
											</table>
											<table class="table table-striped table-hover table-bordered">
												<tr class="thead-dark text-center">
													<th>Sku (Para Despacho)</th>
													<th>Muestra Enológica</th>
													<th>Con Degustación</th>
													<th>Requiere Trasvasije</th>
													<th>Vino No Real</th>
													<th>No Maquetar</th>
													<th>Con Cosecha Histórica/Próxima</th>
													<th>Cosecha Final <i class="fas fa-info-circle text-muted ml-1" title="Para despacho"></i></th>
												</tr>
												<tr class="text-center" style="font-size: 20px !important;">
													<td>
														<span class="badge badge-success p-2">{{ item.finalSku }}</span>
													</td>
													<td>
														<i v-if="item.wineSample" class="fa fa-check text-success"></i>
														<i v-if="!item.wineSample" class="fa fa-times text-danger"></i>
													</td>
													<td>
														<i v-if="item.withTasting" class="fa fa-check text-success"></i>
														<i v-if="!item.withTasting" class="fa fa-times text-danger"></i>
													</td>
													<td>
														<i v-if="item.requireTransfer" class="fa fa-check text-success"></i>
														<i v-if="!item.requireTransfer" class="fa fa-times text-danger"></i>
													</td>
													<td>
														<i v-if="item.notRealWine" class="fa fa-check text-success"></i>
														<i v-if="!item.notRealWine" class="fa fa-times text-danger"></i>
													</td>
													<td>
														<i v-if="item.notLayout" class="fa fa-check text-success"></i>
														<i v-if="!item.notLayout" class="fa fa-times text-danger"></i>
													</td>
													<td>
														<i v-if="item.isHistoricalOrUpcoming" class="fa fa-check text-success"></i>
														<i v-if="!item.isHistoricalOrUpcoming" class="fa fa-times text-danger"></i>
													</td>
													<td>
														<span class="badge badge-success p-2">{{ item.finalHarvest }}</span>
													</td>
												</tr>
											</table>
											<table class="table table-striped table-hover table-bordered"
												v-if="item.estimatedDeliveryDateOenology
													|| item.deliveryDateOenology
													|| item.wineryValidatedAt
													|| item.qualityValidationDate
													|| item.wineryDispatch
													|| item.internalDispatchGuide"    
												>
												<tr class="thead-dark">
													<th v-if="item.estimatedDeliveryDateOenology">Entrega Estimada Enología</th>
													<th v-if="item.deliveryDateOenology">Entrega Enología</th>
													<th v-if="item.wineryValidatedAt">Validación de Componentes</th>
													<th v-if="item.qualityValidationDate">Validación de Calidad</th>
													<th v-if="item.wineryDispatch">Despacho desde Bodega</th>
													<th v-if="item.internalDispatchGuide">N° Guía Bodega</th>
												</tr>
												<tr>
													<td v-if="item.estimatedDeliveryDateOenology">
														<span class="badge badge-warning" style="font-size: 16px">{{
															item.estimatedDeliveryDateOenologyString
														}}</span>
													</td>
													<td v-if="item.deliveryDateOenology">
														<span class="badge badge-success" style="font-size: 16px">{{
															item.deliveryDateOenologyString
														}}</span>
													</td>
													<td v-if="item.wineryValidatedAt">
														<span class="badge badge-success"
															style="font-size: 16px">{{ item.wineryValidatedAtString }}</span>
													</td>
													<td v-if="item.qualityValidationDate">
														<span class="badge badge-success" style="font-size: 16px">
															{{ item.qualityValidationDateString }}
														</span>
													</td>
													<td v-if="item.wineryDispatch">
														<span class="badge badge-success" style="font-size: 16px">{{
															item.wineryDispatchString
														}}</span>
													</td>
													<td v-if="item.internalDispatchGuide">
														<span class="badge badge-primary" style="font-size: 16px">{{
															item.internalDispatchGuide
														}}</span>
													</td>
												</tr>
											</table>
											<div v-if="item.reasonRedoComponents" class="card mb-4 bg-warning">
												<div class="card-body">
													<span class="text-white">
														<b>Motivo de revisión: </b>
														{{ item.reasonRedoComponents }}
													</span>
												</div>
											</div>
											<div v-if="item.rejectionReason" class="card mb-4 bg-danger">
												<span class="text-white">
													<b>Motivo de rechazo: </b>
													{{ item.rejectionReason }}
												</span>
											</div>
											<div v-if="item.cancelledReason">
												<span class="text-white">
													<b>Motivo de cancelación: </b>
													{{ item.cancelledReason }}
												</span>
											</div>
											<a :aria-controls="'collapse' + item.id" :href="'#collapse' + item.id"
												aria-expanded="false" class="btn btn-info btn-block" data-toggle="collapse"
												role="button" @click="ChangeIconCollapse(item.id)">Ver más
												<i :id="'icon' + item.id" class="fas fa-angle-down"></i>
											</a>
											<div :id="`collapse${item.id}`" class="row collapse multi-collapse mt-2">
												<div class="col-lg-6 col-md-12 col-sm-12 mt-2">
													<table class="table table-striped table-hover table-bordered">
														<thead class="thead-dark">
															<tr>
																<th colspan="4">
																	<div class="row">
																		<div class="col-md-6">
																			Componentes Asociados
																		</div>
																		<div class="col-md-6 text-right">
																			Zona de venta:
																			<span class="ml-2">{{ item.saleZone }}</span>
																		</div>
																	</div>
																</th>
															</tr>
														</thead>
														<thead class="thead-light">
															<th style="width: 8%">Posición</th>
															<th style="width: 15%">Código</th>
															<th>Componente</th>
														</thead>
														<tr v-for="lc in item.components" :key="lc.id">
															<td>
																{{ lc.componentPosition }}
															</td>														
															<td style="width: 15%" v-if="lc.requestCommercialSampleDetailId === item.id">
																{{ lc.c_sku }}
															</td>
															<td v-if="lc.requestCommercialSampleDetailId === item.id">
																{{ lc.d_sku }}
															</td>	
														</tr>
													</table>
													<table class="table table-striped table-bordered">
														<tr class="thead-dark">
															<th colspan="2">Semielaborado</th>
														</tr>
														<tr>
															<td>{{ item.semiElaborateCode }}</td>
															<td>{{ item.semiElaborateName }}</td>
														</tr>
													</table>
													<table class="table table-striped table-bordered">
														<tr class="thead-dark">
															<th colspan="2">Otro Semielaborado:</th>
														</tr>
														<tr v-if="item.otherSemiElaborateCode">
															<td style="width: 22%">
																{{ item.otherSemiElaborateCode }}
															</td>
															<td style="width: 78%;">
																{{ item.otherSemiElaborateName }}
															</td>
														</tr>
														<tr v-else="">
															<td colspan="2">
																<span class="badge badge-info">No Establecido</span>
															</td>
														</tr>																																						
													</table>
												</div>
												<div class="col-lg-6 col-md-12 col-sm-12">
													<table v-if="item.requestSampleDetailForDispatch" class="table table-striped table-hover table-bordered">
														<thead class="thead-dark">
															<tr>
																<th colspan="2">Componentes Asignados por el Área de Despacho</th>
															</tr>
														</thead>													
														<thead class="thead-light">
															<tr>
																<th colspan="2">
																	Zona de venta:
																	<span v-if="item.requestSampleDetailForDispatch.saleZoneName" class="ml-2">{{ item.requestSampleDetailForDispatch.saleZoneName }}</span>
																	<span v-else="" class="ml-2">{{ item.requestSampleDetailForDispatch.saleZoneCode }}</span>
																</th>
															</tr>
														</thead>
														<template v-if="item.requestSampleDetailForDispatch">
															<thead class="thead-light">
																<tr>
																	<th style="width: 15%">Código</th>
																	<th>Componente</th>
																</tr>
															</thead>
															<tr v-for="dc in item.requestSampleDetailForDispatch.requestSampleDetailForDispatchComponents" :key="dc.id">
																<td>{{ dc.componentCode }}</td>
																<td>{{ dc.component }}</td>
															</tr>
														</template>
													</table>
													<table class="table table-striped table-hover table-bordered">
														<thead class="thead-light">
															<tr>
																<th style="width: 25%">
																	Obs. Preparación del Vino
																</th>
																<td>{{ item.preparationRemarks }}</td>
															</tr>
															<tr>
																<th>Glosa Sticker</th>
																<td>{{ item.stickerGloss }}</td>
															</tr>
															<tr>
																<th>Confección Packaging</th>
																<td>{{ item.confectionRemarks }}</td>
															</tr>
														</thead>
													</table>
												</div>
												<div class="col-md-12">
													<table class="table table-stripped table-bordered">
														<thead class="thead-light">
															<tr>
																<th colspan="3">Observaciones Adicionales</th>
															</tr>
															<tr v-if="item.requestDetailObservations">
																<th style="width: 18%">Fecha</th>
																<th style="width: 12%">Usuario</th>
																<th style="width: 70%">Observación</th>
															</tr>
														</thead>
														<tbody>
															<tr v-for="observation in item.requestDetailObservations" :key="observation.id">
																<td>{{ observation.createdAtString }}</td>
																<td>{{ observation.email }}</td>
																<td>{{ observation.observation }}</td>
															</tr>
															<tr>
																<td colspan="3">
																	<div class="row">
																		<div class="col-10">
																			<input class="form-control" :id="'observation-input-' + item.id" type="text" />
																		</div>
																		<div class="col-2">
																			<button class="btn btn-success float-right" @click="addObservation(item.id)">
																				<i class="fa fa-save"></i>
																				<span class="ml-2">Registrar Observación</span>
																			</button>
																		</div>
																	</div>
																</td>
															</tr>
														</tbody>
													</table>
												</div>
												<div class="col-md-12">
													<table class="table table-stripped table-hover table-bordered">
														<thead class="thead-light">
															<tr>
																<th colspan="5">Documentos Adjuntos</th>
															</tr>
															<tr v-if="item.documentFiles.length > 0">
																<th style="width: 18%">Usuario</th>
																<th style="width: 12%">Fecha de Carga</th>
																<th style="width: 54%">Nombre del Archivo</th>
																<th style="width: 8%">Tipo de Archivo</th>
																<th style="width: 8%">Opciones</th>
															</tr>
														</thead>
														<tbody>
															<tr v-for="doc in item.documentFiles" :key="doc.id">
																<td>{{ doc.email }}</td>
																<td>{{ doc.createdAtString }}</td>
																<td>{{ doc.fileName }}</td>
																<td style="font-size: 20px">
																	<span v-if="doc.fileExtension == '.pdf'"
																		class="text-danger"><i aria-hidden="true"
																			class="fas fa-file-pdf"></i></span>
																	<span v-if="doc.fileExtension == '.jpg' ||
																		doc.fileExtension == '.png'
																		" class="text-info"><i aria-hidden="true" class="fas fa-image"></i></span>
																	<span v-if="doc.fileExtension == '.xls' ||
																		doc.fileExtension == '.xlsx'
																		" class="text-success"><i aria-hidden="true" class="fas fa-file-excel"></i></span>
																	<span v-if="doc.fileExtension == '.doc' ||
																		doc.fileExtension == '.docx'
																		" class="text-primary"><i class="fas fa-file-word"></i></span>
																</td>
																<td>
																	<button class="btn btn-sm btn-success mr-2"
																		@click="downloadFile(doc.id)">
																		<i class="fa fa-download"></i>
																	</button>
																</td>
															</tr>
														</tbody>
													</table>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</card>
				<card v-if="detailBottle.length > 0" title="Producto Guarda Botella">
					<div class="table-responsive">
						<div v-for="item in detailBottle" :key="item.id">
							<div class="card mb-4 cardShadow">
								<span :id="`detailid-${item.id}`" :data-detailid="item.id"
									:data-validated="item.wineryValidatedAt != null ? 1 : 0" style="display: none"></span>
								<div class="card-header">
									<div class="row">
										<div class="col-md-8">
											<h5 class="card-title d-inline"><b>CÓDIGO: {{ item.sku }}</b></h5>
										</div>
										<div class="col-md-4 text-right">
											<b-form-checkbox v-if="item.sampleDetailStage == 5 && request.requiredDispatch" class="mt-2"
												switch @change="addSample(item)">
												Seleccionado
											</b-form-checkbox>
										</div>
									</div>
								</div>
								<div class="card-body">
									<div class="row">
										<div class="col-md-12">
											<table class="table table-striped table-hover table-bordered">
												<thead class="thead-dark">
													<tr>
														<th>Código</th>
														<th>Marca</th>
														<th v-if="item.comercialMixCode" style="width: 20%">
															Mezcla Comercial
														</th>
														<th>Vino</th>
														<th>Botellas</th>
														<th>Etapa</th>
													</tr>
												</thead>
												<tbody>
													<tr style="font-size: 20px !important;">
														<td>
															<span class="badge badge-info p-2">{{ item.sku }}</span>
														</td>
														<td><span class="badge badge-info p-2">{{ item.brand }}</span>
														</td>
														<td v-if="item.comercialMixCode">
															<span class="badge badge-info p-2">{{ item.comercialMix }} - {{ item.comercialMixCode }}</span>
														</td>
														<td>
															<span class="badge badge-info p-2">{{ item.variety }}</span> 
																														<span class="badge badge-info p-2 ml-1">{{ item.valley }}</span>
															<span class="badge badge-info p-2 ml-1">{{ item.quality }}</span>
														</td>
														<td>
															<span class="badge badge-success p-2">{{ item.quantity }}</span>
														</td>
														<td>
															<span class="badge badge-info p-2">
																<i class="fa fa-info-circle"></i>
																{{ item.stage }}
															</span>
														</td>
													</tr>
												</tbody>
											</table>
											<table class="table table-striped table-hover table-bordered">
												<tr class="thead-dark text-center">
													<th>Con Degustación</th>
													<th>Requiere Trasvasije</th>
													<th>Con Cosecha Histórica/Próxima</th>
													<th>Cosecha Final <i class="fas fa-info-circle text-muted ml-1" title="Para despacho"></i></th>
												</tr>
												<tr class="text-center" style="font-size: 20px !important;">
													<td>
														<i v-if="item.withTasting" class="fa fa-check text-success"></i>
														<i v-if="!item.withTasting" class="fa fa-times text-danger"></i>
													</td>
													<td>
														<i v-if="item.requireTransfer" class="fa fa-check text-success"></i>
														<i v-if="!item.requireTransfer" class="fa fa-times text-danger"></i>
													</td>
													<td>
														<i v-if="item.isHistoricalOrUpcoming" class="fa fa-check text-success"></i>
														<i v-if="!item.isHistoricalOrUpcoming" class="fa fa-times text-danger"></i>
													</td>
													<td>
														<span class="badge badge-success p-2">{{ item.finalHarvest }}</span>
													</td>
												</tr>
											</table>
											<table class="table table-striped table-hover table-bordered"
												v-if="item.wineryValidatedAt
													|| item.qualityValidationDate
													|| item.wineryDispatch
													|| item.internalDispatchGuide"  
												>
												<tr class="thead-dark">
													<th v-if="item.wineryValidatedAt">Validación de Componentes</th>
													<th v-if="item.qualityValidationDate">Validación de Calidad</th>
													<th v-if="item.wineryDispatch">Despacho desde Bodega</th>
													<th v-if="item.internalDispatchGuide">N° Guía Bodega</th>
												</tr>
												<tr>
													<td v-if="item.wineryValidatedAt">
														<span class="badge badge-success"
															style="font-size: 16px">{{ item.wineryValidatedAtString }}</span>
													</td>
													<td v-if="item.qualityValidationDate">
														<span class="badge badge-success" style="font-size: 16px">
															{{ item.qualityValidationDateString }}
														</span>
													</td>
													<td v-if="item.wineryDispatch">
														<span class="badge badge-success" style="font-size: 16px">{{
															item.wineryDispatchString
														}}</span>
													</td>
													<td v-if="item.internalDispatchGuide">
														<span class="badge badge-primary" style="font-size: 16px">{{
															item.internalDispatchGuide
														}}</span>
													</td>
												</tr>
											</table>
											<div v-if="item.reasonRedoComponents" class="card mb-4 bg-warning">
												<div class="card-body">
													<span class="text-white">
														<b>Motivo de revisión: </b>
														{{ item.reasonRedoComponents }}
													</span>
												</div>
											</div>
											<div v-if="item.rejectionReason" class="card mb-4 bg-danger">
												<span class="text-white">
													<b>Motivo de rechazo: </b>
													{{ item.rejectionReason }}
												</span>
											</div>
											<div v-if="item.cancelledReason">
												<span class="text-white">
													<b>Motivo de cancelación: </b>
													{{ item.cancelledReason }}
												</span>
											</div>
											<a :aria-controls="'collapse' + item.id" :href="'#collapse' + item.id"
												aria-expanded="false" class="btn btn-info btn-block" data-toggle="collapse"
												role="button" @click="ChangeIconCollapse(item.id)">Ver más
												<i :id="'icon' + item.id" class="fas fa-angle-down"></i>
											</a>
											<div :id="`collapse${item.id}`" class="row collapse multi-collapse mt-2">
												<div class="col-lg-6 col-md-12 col-sm-12">
													<table class="table table-striper table-hover table-bordered">
														<thead class="thead-dark"> 
															<tr>
																<th colspan="5">Componentes Asociados</th>
															</tr>
														</thead>
														<thead class="thead-light">
															<tr>
																<th style="width: 20%">Tipo</th>
																<th style="width: 15%">Código</th>
																<th>Descripción</th>
															</tr>
														</thead>												
														<thead class="thead-light">
															<tr>
																<th>Capsula</th>
																<td>{{ item.capsuleCode }}</td>
																<td>{{ item.capsuleName }}</td>																
															</tr>
															<tr>
																<th>Tapa</th>
																<td>{{ item.cappingCode }}</td>
																<td>{{ item.cappingName }}</td>															
															</tr>
															<tr>
																<th>Caja</th>
																<td>{{ item.boxCode }}</td>
																<td>{{ item.boxName }}</td>															
															</tr>
															<tr>
																<th>Botella</th>
																<td>{{ item.bottleCode }}</td>
																<td>{{ item.bottleName }}</td>
															</tr>
															<tr v-if="item.labelName">
																<th>Etiqueta</th>
																<td>{{ item.labelCode }}</td>
																<td>{{ item.labelName }}</td>
															</tr>
															<tr v-if="item.backLabelName">
																<th>Contraetiqueta</th>
																<td>{{ item.backLabelCode }}</td>
																<td>{{ item.backLabelName }}</td>
															</tr>
														</thead>
													</table>
												</div>
												<div class="col-lg-6 col-md-12 col-sm-12">
													<table v-if="item.requestSampleDetailForDispatch" class="table table-striped table-hover table-bordered">
														<thead class="thead-dark">
															<tr>
																<th colspan="3">
																	Componentes Asignados por el Área de Despacho
																</th>
															</tr>
														</thead>
														<thead class="thead-light">
															<tr>
																<th style="width: 12%">Tipo</th>
																<th style="width: 15%">Código</th>
																<th>Componente</th>
															</tr>
															<tr v-for="dc in item.requestSampleDetailForDispatch.requestSampleDetailForDispatchComponents"
																:key="dc.id">
																<th style="width: 16%;"> {{ dc.family }}</th>
																<td style="width: 15%"> {{ dc.componentCode }}</td>
																<td>{{ dc.component }} </td>
															</tr>
														</thead>
													</table>
													<table class="table table-striped table-hover table-bordered">
														<thead class="thead-light">
															<tr>
																<th style="width: 25%">
																	Obs. Preparación del Vino
																</th>
																<td>{{ item.preparationRemarks }}</td>
															</tr>
															<tr>
																<th>Glosa Sticker</th>
																<td>{{ item.stickerGloss }}</td>
															</tr>
															<tr>
																<th>Confección Packaging</th>
																<td>{{ item.confectionRemarks }}</td>
															</tr>
														</thead>
													</table>
												</div>
												<div class="col-md-12">
													<table class="table table-stripped table-bordered">
														<thead class="thead-light">
															<tr>
																<th colspan="3">Observaciones Adicionales</th>
															</tr>
															<tr v-if="item.requestDetailObservations">
																<th style="width: 18%">Fecha</th>
																<th style="width: 12%">Usuario</th>
																<th style="width: 70%">Observación</th>
															</tr>
														</thead>
														<tbody>
															<tr v-for="observation in item.requestDetailObservations" :key="observation.id">
																<td>{{ observation.createdAtString }}</td>
																<td>{{ observation.email }}</td>
																<td>{{ observation.observation }}</td>
															</tr>
															<tr>
																<td colspan="3">
																	<div class="row">
																		<div class="col-10">
																			<input class="form-control" :id="'observation-input-' + item.id" type="text" />
																		</div>
																		<div class="col-2">
																			<button class="btn btn-success float-right" @click="addObservation(item.id)">
																				<i class="fa fa-save"></i>
																				<span class="ml-2">Registrar Observación</span>
																			</button>
																		</div>
																	</div>
																</td>
															</tr>
														</tbody>
													</table>
												</div>
												<div class="col-md-12">
													<table class="table table-stripped table-hover table-bordered">
														<thead class="thead-light">
															<tr>
																<th colspan="5">Documentos Adjuntos</th>
															</tr>
															<tr v-if="item.documentFiles.length > 0">
																<th style="width: 18%">Usuario</th>
																<th style="width: 12%">Fecha de Carga</th>
																<th style="width: 54%">Nombre del Archivo</th>
																<th style="width: 8%">Tipo de Archivo</th>
																<th style="width: 8%">Opciones</th>
															</tr>
														</thead>
														<tbody>
															<tr v-for="doc in item.documentFiles" :key="doc.id">
																<td>{{ doc.email }}</td>
																<td>{{ doc.createdAtString }}</td>
																<td>{{ doc.fileName }}</td>
																<td style="font-size: 20px">
																	<span v-if="doc.fileExtension == '.pdf'"
																		class="text-danger"><i aria-hidden="true"
																			class="fas fa-file-pdf"></i></span>
																	<span v-if="doc.fileExtension == '.jpg' ||
																		doc.fileExtension == '.png'
																		" class="text-info"><i aria-hidden="true" class="fas fa-image"></i></span>
																	<span v-if="doc.fileExtension == '.xls' ||
																		doc.fileExtension == '.xlsx'
																		" class="text-success"><i aria-hidden="true" class="fas fa-file-excel"></i></span>
																	<span v-if="doc.fileExtension == '.doc' ||
																		doc.fileExtension == '.docx'
																		" class="text-primary"><i class="fas fa-file-word"></i></span>
																</td>
																<td>
																	<button class="btn btn-sm btn-success mr-2"
																		@click="downloadFile(doc.id)">
																		<i class="fa fa-download"></i>
																	</button>
																</td>
															</tr>
														</tbody>
													</table>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</card>
			</div>
		</div>
		<modal id="dispatchSelection" :lg="true" title="Realizar Despacho">
			<dispatch-modal :id="id" :detailBottle="detailBottleToDispatch" :detailFinish="detailFinishToDispatch"
				:detailNew="detailNewToDispatch" :internalDispatchGuide="internalDispatchGuide" :shippingDate="shippingDate"
				@dispatch="dispatch"></dispatch-modal>
		</modal>
	</card>
</template>

<script>
import { Get, Post, Put } from "@/helper/axios";
import $ from "jquery";
import DispatchModal from "@/views/requests/internalDispatch/dispatchModal.vue";

export default {
	components: { DispatchModal },
	props: ["details", "id", "component", "request"],
	data() {
		return {
			Get,
			Post,
			Put,
			apiUrl: this.$store.getters.apiUrl,
			detailId: 0,
			listSelectSample: [],
			exist: false,
			shippingDate: "",
			internalDispatchGuide: "",
			stock: {}
		};
	},
	methods: {
		ChangeIconCollapse(item) {
			if ($(`#icon${item}`).hasClass("fa-angle-down"))
				$(`#icon${item}`).toggleClass("fa-angle-up");
			else if ($(`#icon${item}`).hasClass("fa-angle-up"))
				$(`#icon${item}`).toggleClass("fa-angle-down");
		},
		showDispatchModal() {
			$(`#dispatchSelection`).modal("show");
		},
		addSample(item) {
			var index = this.listSelectSample.indexOf(item);
			if (index == -1) {
				this.listSelectSample.push(item);
			} else {
				this.listSelectSample.splice(index, 1);
			}
		},
		dispatch(shippingDate, internalDispatchGuide) {
			var dispatchDetails = [];
			if (this.listSelectSample.length > 0) {
				dispatchDetails = this.listSelectSample.map(function (item) {
					return item.id;
				});
			} else {
				dispatchDetails = this.details
					.filter((x) => x.sampleDetailStage === 5)
					.map(function (item) {
						return item.id;
					});
			}
			this.$swal({
				title: "Realizar Despacho",
				text: "¿Está seguro de realizar el despacho?",
				icon: "info",
				html: `</br><h5>Datos a registrar</h5><table class="table table-sm table-bordered text-left"><tr><th>Fecha de Envío: </th><td>${shippingDate}</td></tr><tr><th>N° Guia de despacho:</th><td>${internalDispatchGuide}</td></tr></table>`,
			}).then((result) => {
				if (result.value) {
					this.updateDispatch = {
						action: "Dispatch",
						list: dispatchDetails,
						date: shippingDate,
						internalDispatchGuide: internalDispatchGuide,
					};
					this.$store.commit("setLoading", true);
					this.Put(
						`${this.apiUrl}v1/details/winerydispatch/${this.id}`,
						this.updateDispatch,
						() => {
							window.toastr.success(
								"Se ha realizado el despacho correctamente."
							);
							this.$store.commit("setLoading", false);
							$(`#dispatchSelection`).modal("hide");
							//this.$router.push("/");
							location.reload();
						}
					);
				}
			});
		},
		addObservation(detailId) {
			this.$store.commit("setLoading", true);
			let obs = document.getElementById("observation-input-" + detailId);
			let data = {
				requestCommercialSampleDetailId: detailId,
				observation: obs.value
			};
			this.Post(`${this.apiUrl}v1/RequestDetailObservations`, data, () => {
				this.$store.commit("setLoading", false);
				window.toastr.success("Se ha registrado la Observación correctamente.");
                obs.value = '';
                this.$emit("updateObservations");
			});
		},
        showStockModal(type, sku, harvest) {
            this.stock = {}
            this.$store.commit("setLoading", true);
            let data = 'Sku=' + sku + '&Type=' + type
            if (harvest)
                data += '&Harvest=' + harvest
            this.Get(this.apiUrl + "v1/MasterItems/GetStock?" + data, (res) => {
                this.stock = res.data;
                this.$swal({
                    title: "Consulta de Stock",
                    html:   `<table class="table table-sm table-bordered text-left">
                                <tr>
                                    <th style="width: 160px">Tipo</th>
                                    <td>`+this.stock.materialDescription +`</td>
                                </tr>
                                <tr>
                                    <th>Sku</th>
                                    <td>`+this.stock.sku +`</td>
                                </tr>
                                <tr>
                                    <th>Descripción</th>
                                    <td>`+this.stock.skuDescription +`</td>
                                </tr>
                                <tr>
                                    <th>Cosecha (Año)</th>
                                    <td>`+this.stock.harvest +`</td>
                                </tr>
                                <tr>
                                    <th>Stock</th>
                                    <td>`+this.stock.stock +`</td>
                                </tr>
                                <tr>
                                    <th>Actualizado</th>
                                    <td>`+this.stock.updatedStockAtString +`</td>
                                </tr>
                            </table>`,
                    icon: "info",
                    confirmButtonColor: "#3085d6",
                    width: 800
                });
            });
            this.$store.commit("setLoading", false);
        },		
	},
	computed: {
		detailNewToDispatch: function () {
			return this.listSelectSample.length > 0
				? this.listSelectSample.filter((x) => x.requestTypeId === 1)
				: this.details.filter(
					(x) => x.sampleDetailStage == 5 && x.requestTypeId === 1
				);
		},
		detailFinishToDispatch: function () {
			return this.listSelectSample.length > 0
				? this.listSelectSample.filter((x) => x.requestTypeId === 2)
				: this.details.filter(
					(x) => x.sampleDetailStage == 5 && x.requestTypeId === 2
				);
		},
		detailBottleToDispatch: function () {
			return this.listSelectSample.length > 0
				? this.listSelectSample.filter((x) => x.requestTypeId === 3)
				: this.details.filter(
					(x) => x.sampleDetailStage == 5 && x.requestTypeId === 3
				);
		},
		detailNew: function () {
			return this.details.filter((x) => x.requestTypeId === 1);
		},
		detailFinish: function () {
			return this.details.filter((x) => x.requestTypeId === 2);
		},
		detailBottle: function () {
			return this.details.filter((x) => x.requestTypeId === 3);
		},
		buttonText: function () {
			return this.listSelectSample.length == 0 ? "Todo" : "Selección";
		},
	},
};
</script>
